import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import DefaultPic from '../../icons/defaultProfilePicture.png';
import { PICTURE_VARIANTS } from '../../common/constants';

function Picture({ source, variant }) {
    if (source == null) {
        source = DefaultPic;
    }

    return (
        <div className={`avatar ${variant}`}>
            <img src={source} alt="" className="rounded-image" />
        </div>
    );
}

Picture.propTypes = {
    // source URL for the Picture
    source: PropTypes.string,

    // To select the size of the Picture from predefined sizes
    variant: PropTypes.string,
};

Picture.defaultProps = {
    source: DefaultPic,
    variant: PICTURE_VARIANTS.VARIANT_SMALL,
};

export default Picture;
